import { formatarTelefone, maskCEP } from "../../utils/validacaoDadosPaciente";

export default function Insert(dadosIniciais, setDadadosIniciais) {
  setDadadosIniciais(prevState => ({
    ...prevState,
    id: dadosIniciais.idPaciente,
    medicoResponsavel: dadosIniciais.medicoResponsavel,
    nome: dadosIniciais.nome,
    nomeSocial: dadosIniciais.nomeSocial,
    nomeMae: dadosIniciais.nomeMae,
    email: dadosIniciais.email,
    dataNascimento: dadosIniciais.dataNascimento,
    dataNascimentoLabel: dadosIniciais.dataNascimentoFormatada,
    naturalidade: dadosIniciais.naturalidade.id,
    naturalidadeLabel: dadosIniciais.naturalidade.descricao,
    estadoNascimento: dadosIniciais.estadoNascimento.id.toString(),
    estadoNascimentoLabel: dadosIniciais.estadoNascimento.descricao,
    municipioNascimento: dadosIniciais.municipioNascimento.id,
    municipioNascimentoLabel: dadosIniciais.municipioNascimento.descricao,
    sexoBiologico: dadosIniciais.sexo.id,
    sexoBiologicoLabel: dadosIniciais.sexo.descricao,
    racaCor: dadosIniciais.raca.id,
    racaCorLabel: dadosIniciais.raca.descricao,
    identidadeGenero: dadosIniciais.identidadeDeGenero.id,
    identidadeGeneroLabel: dadosIniciais.identidadeDeGenero.descricao,
    estadoCivil: dadosIniciais.estadoCivil.id,
    estadoCivilLabel: dadosIniciais.estadoCivil.descricao,
    religiao: dadosIniciais.religiao.id,
    religiaoLabel: dadosIniciais.religiao.descricao,
    lateralidade: dadosIniciais.lateralidade.id,
    lateralidadeLabel: dadosIniciais.lateralidade.descricao,
    escolaridade: dadosIniciais.escolaridade.id,
    escolaridadeLabel: dadosIniciais.escolaridade.descricao,
    profissao: dadosIniciais.profissao.id,
    profissaoLabel: dadosIniciais.profissao.descricao,
    tipoTrabalho: dadosIniciais.tipoDeTrabalho.id,
    tipoTrabalhoLabel: dadosIniciais.tipoDeTrabalho.descricao,
    condicaoAtual: dadosIniciais.condicaoAtual.id,
    condicaoAtualLabel: dadosIniciais.condicaoAtual.descricao,
    tempoCondicaoAtual: dadosIniciais.tempoDedicacao,
    ultimasAtividadesProfissionais: dadosIniciais.atividadesProfissionais,
    enderecoCep: maskCEP(dadosIniciais.endereco.cep),
    enderecoUf: dadosIniciais.endereco.estado.descricao,
    enderecoCodigoUf: dadosIniciais.endereco.estado.id,
    enderecoMunicipio: dadosIniciais.endereco.municipio.descricao,
    enderecoIBGE: dadosIniciais.endereco.municipio.id,
    enderecoLogradouro: dadosIniciais.endereco.logradouro,
    enderecoBairro: dadosIniciais.endereco.bairro,
    enderecoNumero: dadosIniciais.endereco.numero,
    enderecoComplemento: dadosIniciais.endereco.complemento,
    numeroTelefone: formatarTelefone(dadosIniciais.contato.telefone),
    responsavelTelefone: dadosIniciais.contato.responsavel,
  }))
}